<template>
    <div>

        <!-- Table -->

        <trax-ui-card-icon-header icon="people" 
            :title="lang.polaris.dashboard.learners" :actions="card_actions" :bus="bus">

            <enac-atpl-dashboard-learners-table :bus="bus">
            </enac-atpl-dashboard-learners-table>

        </trax-ui-card-icon-header>

        <!-- Search modal -->

        <trax-ui-modal-default :id="id+'-search'" :bus="bus" :title="lang.polaris.form.advanced_search">
            <enac-atpl-dashboard-learners-search :id="id" :bus="bus"></enac-atpl-dashboard-learners-search>
        </trax-ui-modal-default>

    </div>
</template>

<script>
    export default {

        props: {
            id: { default: 'home-learners' },
        },

        data: function() {
            return {
                user: user,
                lang: lang,
                bus: new Vue()
            }
        },

        computed: {

            card_actions() {
                var actions = [];
                if (this.filterPermission) {
                    actions.push({ icon: 'search', event: this.id + '-search-open' });
                }
                return actions;
            },

            filterPermission() {
                return this.user.admin 
                    || this.user.permissions['dashboard.read-mine-locations']
                    || this.user.permissions['dashboard.read-all']
                    || this.user.permissions['dashboard.write-mine-locations']
                    || this.user.permissions['dashboard.write-all'];
            }
        }
    }
</script>
